'use client';
import { useEffect } from 'react';
import Image from 'next/image';
import styles from './FloatingMarquee.module.css';

export default function FloatingMarquee() {
  // Actual supplement images from your Listing component
  const supplements = [
    'https://longevity20155.sirv.com/minci/1.webp',
    'https://longevity20155.sirv.com/minci/2.webp',
    'https://longevity20155.sirv.com/minci/3.webp',
    'https://longevity20155.sirv.com/zinc/1.webp',
    'https://longevity20155.sirv.com/zinc/2.webp',
    'https://longevity20155.sirv.com/zinc/3.webp',
    'https://longevity20155.sirv.com/testo/1.webp',
    'https://longevity20155.sirv.com/testo/2.webp',
    'https://longevity20155.sirv.com/testo/3.webp',
  ];

  const supplements2 = [
    'https://longevity20155.sirv.com/testo/1.webp',
    'https://longevity20155.sirv.com/testo/2.webp',
    'https://longevity20155.sirv.com/testo/3.webp',
    'https://longevity20155.sirv.com/minci/1.webp',
    'https://longevity20155.sirv.com/minci/2.webp',
    'https://longevity20155.sirv.com/minci/3.webp',
    'https://longevity20155.sirv.com/zinc/1.webp',
    'https://longevity20155.sirv.com/zinc/2.webp',
    'https://longevity20155.sirv.com/zinc/3.webp',
  ];


  return (
    <div className={styles.marqueeWrapper} id='marqueeWrapper'>
      {/* Left side - 2 columns */}
      <div className={styles.leftSide}>
        {/* Column 1 - Moving up */}
        <div className={`${styles.marqueeColumn} ${styles.columnUp}`}>
          {/* First set */}
          <div className={styles.marqueeSet}>
            {supplements.map((img, idx) => (
              <div key={`set1-${idx}`} className={styles.floatingItem}>
                <Image src={img} alt="" width={200} height={200} unoptimized priority={true} />
              </div>
            ))}
          </div>
          {/* Duplicate set for seamless loop */}
          <div className={styles.marqueeSet}>
            {supplements.map((img, idx) => (
              <div key={`set2-${idx}`} className={styles.floatingItem}>
                <Image src={img} alt="" width={200} height={200} unoptimized priority={true} />
              </div>
            ))}
          </div>
        </div>

        {/* Column 2 - Moving down */}
        <div className={`${styles.marqueeColumn} ${styles.columnDown}`}>
          {/* First set */}
          <div className={styles.marqueeSet}>
            {supplements.map((img, idx) => (
              <div key={`set1-${idx}`} className={styles.floatingItem}>
                <Image src={img} alt="" width={200} height={200} unoptimized priority={true} />
              </div>
            ))}
          </div>
          {/* Duplicate set for seamless loop */}
          <div className={styles.marqueeSet}>
            {supplements.map((img, idx) => (
              <div key={`set2-${idx}`} className={styles.floatingItem}>
                <Image src={img} alt="" width={200} height={200} unoptimized priority={true}/>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right side - 2 columns */}
      <div className={styles.rightSide}>
        {/* Column 3 - Moving up */}
        <div className={`${styles.marqueeColumn} ${styles.columnUp}`}>
          {/* First set */}
          <div className={styles.marqueeSet}>
            {supplements2.map((img, idx) => (
              <div key={`set1-${idx}`} className={styles.floatingItem}>
                <Image src={img} alt="" width={200} height={200} unoptimized priority={true} />
              </div>
            ))}
          </div>
          {/* Duplicate set for seamless loop */}
          <div className={styles.marqueeSet}>
            {supplements2.map((img, idx) => (
              <div key={`set2-${idx}`} className={styles.floatingItem}>
                <Image src={img} alt="" width={200} height={200} unoptimized priority={true} />
              </div>
            ))}
          </div>
        </div>

        {/* Column 4 - Moving down */}
        <div className={`${styles.marqueeColumn} ${styles.columnDown}`}>
          {/* First set */}
          <div className={styles.marqueeSet}>
            {supplements.map((img, idx) => (
              <div key={`set1-${idx}`} className={styles.floatingItem}>
                <Image src={img} alt="" width={200} height={200} unoptimized priority={true} />
              </div>
            ))}
          </div>
          {/* Duplicate set for seamless loop */}
          <div className={styles.marqueeSet}>
            {supplements.map((img, idx) => (
              <div key={`set2-${idx}`} className={styles.floatingItem}>
                <Image src={img} alt="" width={200} height={200} unoptimized priority={true} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
